import React, { Component } from "react";
import { Icon, Popup } from "semantic-ui-react";

class MessageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
    this.jumpToMerchandise = this.jumpToMerchandise.bind();
  }

  jumpToMerchandise = (id, lineNumber) => {
    this.props.closseAce();

    let elementToOpen = "merchandiseDetail-".concat(id);
    console.log(elementToOpen, "element");
    var expandMerchandise = document.getElementById(elementToOpen);
    if (expandMerchandise === null) {
      return !window.confirm("Make sure you are on Items tab");
    } else {
      setTimeout(() => {
        expandMerchandise && expandMerchandise.click();
        expandMerchandise &&
          expandMerchandise.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });

        return null;
      }, 0);
    }
  };

  render() {
    let { item } = this.props;

    if (item.hasOwnProperty("errors") === false) {
      return (
        <div className="" style={{ marginTop: "10px" }}>
          <div id="message-header" style={{ fontSize: "11px" }}>
            <div>
              CHIEF
              <span style={{ marginLeft: "70px", fontWeight: "bold" }}>
                {item.hasOwnProperty("reportType") === true
                  ? item.hasOwnProperty("reportDescription") === true ?  item.reportDescription.concat("(Print Message)") : ""
                  : item.messageCode === "EFD"
                  ? "EXPORT ENTRY ACCEPTANCE ADVICE"
                  : item.messageCode === "IFD" ? "IMPORT ENTRY ACCEPTANCE ADVICE" : 
                  item.messageCode === "XTC"?  "CANCELLATION ADVICE":""}
              </span>
              {(item.hasOwnProperty("entryCreationDate") === true ||
                item.hasOwnProperty("entryAcceptanceDate") === true) && (
                <div style={{ float: "right", textTransform: "lowercase" }}>
                  at{" "}
                  {item.hasOwnProperty("reportType") === false
                    ? item.entryCreationDate &&
                      item.entryCreationDate.substring(8, 10) +
                        ":" +
                        item.entryCreationDate.substring(10, 12)
                    : item.entryAcceptanceDate &&
                      item.entryAcceptanceDate.substring(8, 10) +
                        "/" +
                        item.entryAcceptanceDate.substring(10, 12)}
                </div>
              )}
            </div>

            <div>
              {item.hasOwnProperty("reportType") === true
                ? item.reportType : item.hasOwnProperty("messageCode") === true && item.messageCode === "XTC"? "XTC" 
                : "DTI-H2"}
              {(item.hasOwnProperty("entryCreationDate") === true ||
                item.hasOwnProperty("entryAcceptanceDate") === true) && (
                <span style={{ float: "right", textTransform: "lowercase" }}>
                  on{" "}
                  {item.hasOwnProperty("reportType") === false
                    ? item.entryCreationDate &&
                      item.entryCreationDate.substring(6, 8) +
                        "/" +
                        item.entryCreationDate.substring(4, 6) +
                        "/" +
                        item.entryCreationDate.substring(0, 4)
                    : item.entryAcceptanceDate &&
                      item.entryAcceptanceDate.substring(6, 8) +
                        "/" +
                        item.entryAcceptanceDate.substring(4, 6) +
                        "/" +
                        item.entryAcceptanceDate.substring(0, 4)}
                </span>
              )}
            </div>

            <div style={{ textAlign: "center", marginLeft: "25px" }}>
              Entry :
              {item.hasOwnProperty("reportType") === false
                ? (item.hasOwnProperty("entryEPUNo") === true
                    ? item.entryEPUNo
                    : "") +
                  "-" +
                  item.entryNumber +
                  "-" +
                  (item.entryCreationDate &&
                    item.entryCreationDate.substring(6, 8) +
                      "/" +
                      item.entryCreationDate.substring(4, 6) +
                      "/" +
                      item.entryCreationDate.substring(0, 4))
                : item.entryNumber}{" "}
              SAD version {item.entryVerNumber}
             {item.hasOwnProperty("userRef")===true &&<span style={{ float: "right" }}>for {item.userRef}</span> }
              <br />
              {item.hasOwnProperty("routeOfEntry") === true ?
                (item.routeOfEntry === "H"  && item.hasOwnProperty("messageLabel") === false 
                  ? "PRE-LODGE ACCEPTANCE" : item.hasOwnProperty("routeOfEntry") === true  && item.hasOwnProperty("messageLabel") === true  ? "Route" + " " + item.routeOfEntry
                  : item.messageCode === "EFD" && item.routeOfEntry === "6"
                  ? "PERMISSION TO PROGRESS"
                  : "Route" + " " + item.routeOfEntry) +
                  " " +
                  "at" +
                  " " +
                  (item.hasOwnProperty("officeEPUNo")=== true ? item.officeEPUNo : "") +
                  " " +
                  "status" +
                  " " +
                  item.customStatus  
                  : item.hasOwnProperty("messageCode") === true && item.messageCode === "XTC" ?
                  `CUSTOM STATUS ${item.customStatus}`
                  : null
                  }
              {/* <span
                style={{
                  float: "right",
                }}
              >
                page 1
              </span> */}
            </div>

            <hr />
          </div>
          <div id="message-body">
            <div id="entry-acceptance-details">
              <div style={{ fontWeight: "bold" }}>ENTRY ACCEPTANCE DETAILS</div>
              {/* <br /> */}
              <div
                style={{
                  marginLeft: "20px",
                  marginTop: "5px",
                  fontWeight: "bold",
                }}
              >
                {item.messageCode === "IFD" ||
                  (item.messageCode === "EFD" &&
                    "ENTRY item HELD PENDING GOODS ARRIVAL")}
              </div>
              <table
                style={{
                  width: "100%",
                  marginLeft: "20px",
                  marginTop: "5px",
                  fontSize: "10px",
                }}
              >
                <tr>
                  {item.hasOwnProperty("reportType") === false &&
                    item.hasOwnProperty("entryCreationDate") === true && (
                      <td>
                        Entry accepted :{" "}
                        {item.entryCreationDate &&
                          item.entryCreationDate.substring(6, 8)}
                        /
                        {item.entryCreationDate &&
                          item.entryCreationDate.substring(4, 6)}
                        /
                        {item.entryCreationDate &&
                          item.entryCreationDate.substring(0, 4)}{" "}
                        at{" "}
                        {item.entryCreationDate &&
                          item.entryCreationDate.substring(8, 10)}
                        :
                        {item.entryCreationDate &&
                          item.entryCreationDate.substring(10, 12)}{" "}
                      </td>
                    )}
                  {item.hasOwnProperty("reportType") === true &&
                    item.hasOwnProperty("entryAcceptanceDate") === true && (
                      <td>
                        Entry accepted :{" "}
                        {item.entryAcceptanceDate &&
                          item.entryAcceptanceDate.substring(6, 8)}
                        /
                        {item.entryAcceptanceDate &&
                          item.entryAcceptanceDate.substring(4, 6)}
                        /
                        {item.entryAcceptanceDate &&
                          item.entryAcceptanceDate.substring(0, 4)}{" "}
                        at{" "}
                        {item.entryAcceptanceDate &&
                          item.entryAcceptanceDate.substring(8, 10)}
                        :
                        {item.entryAcceptanceDate &&
                          item.entryAcceptanceDate.substring(10, 12)}{" "}
                      </td>
                    )}
                  {item.hasOwnProperty("officeEPUNo") === true && (
                    <td>Office : {item.officeEPUNo}</td>
                  )}
                </tr>
                <tr>
                  {item.hasOwnProperty("declarantTID") === true && (
                    <td>Declarant Id : {item.declarantTID}</td>
                  )}
                  {item.hasOwnProperty("submittingTurn") === true && (
                    <td>Submitting TURN : {item.submittingTurn}</td>
                  )}
                  {/* <td>{item.sysMRN}</td> */}
                </tr>
                {item.hasOwnProperty("entryNumber") === true && (
                  <tr>
                    <td>Entry Reference : {item.entryNumber}</td>
                  </tr>
                )}
                {item.hasOwnProperty("entryUniqueId") === true && (
                  <tr>
                    <td> Entry Key : {item.entryUniqueId}</td>
                  </tr>
                )}
                {item.hasOwnProperty("entryType") === true && (
                  <tr>
                    <td>Entry Type : {item.entryType}</td>
                  </tr>
                )}
                {item.hasOwnProperty("traderRefNumber") === true && (
                  <tr>
                    <td>Declarant reference : {item.traderRefNumber}</td>
                  </tr>
                )}
              </table>
            </div>
            <div id="consignment-details" style={{ marginTop: "5px" }}>
              <div style={{ fontWeight: "bold" }}>CONSIGNMENT DETAILS</div>
              <table
                style={{
                  width: "100%",
                  marginLeft: "20px",
                  marginTop: "4px",
                  fontSize: "10px",
                }}
              >
                <tr>
                  {item.hasOwnProperty("ducr") === true && (
                    <td>Decln UCR : {item.ducr}</td>
                  )}
                  {item.hasOwnProperty("ducrPartNo") === true && (
                    <td>part : {item.ducrPartNo}</td>
                  )}
                  {/* <td style={{ paddingRight: "10px" }}></td> */}
                </tr>
                {item.hasOwnProperty("mrn") === true && (
                  <tr>
                    <td>MRN : {item.mrn}</td>

                    {/* <td>GB949132941000</td>
                <td>ACME</td>
                <td>UK</td> */}
                  </tr>
                )}
                {item.hasOwnProperty("consigneeTID") === true && item.hasOwnProperty("consigneeName") === true && (
                  <tr>
                    <td>Consignee : {item.consigneeTID+" "+  item.consigneeName}</td>
                  </tr>
                )}
                {item.hasOwnProperty("consignorTID") === true && item.hasOwnProperty("consignorName") === true && (
                  <tr>
                    <td>Consignor : {item.consignorTID+" "+ item.consignorName}</td>
                  </tr>
                )}
                {/* 
                <td>Inventory system</td>
                <td>FCP1</td>
              </tr> */}
                <tr>
                  {item.hasOwnProperty("masterUCR") === true && (
                    <td>Master UCR : {item.masterUCR}</td>
                  )}
                  {/* <td>Total packages</td>
                <td>26</td> */}
                </tr>
                <tr>
                  {item.hasOwnProperty("goodsLocationCode") === true && (
                    <td>Location : {item.goodsLocationCode}</td>
                  )}
                  {/* <td>Total packages</td>
                <td>26</td> */}
                </tr>
              </table>
            </div>
            {item.hasOwnProperty("segments") === true &&
              item.segments.map(
                (element) =>
                  element.hasOwnProperty("body") === true &&
                  element.hasOwnProperty("header") === true && (
                    <>
                      <div style={{ fontWeight: "bold" }}>{element.header}</div>
                      <table style={{ marginLeft: "20px" }}>
                        {element.body.map((item) => (
                          <tr>
                            {item.hasOwnProperty("key") === true &&
                              item.hasOwnProperty("value") === true && (
                                <td>
                                  {item.key} : {item.value}
                                </td>
                              )}
                          </tr>
                        ))}
                      </table>
                      <br />
                    </>
                  )
              )}

            {item.hasOwnProperty("amendedShipmentDuties") === true && (
              <>
                <div style={{ fontWeight: "bold" }}>
                  REVENUE CHANGES FOR ENTRY
                </div>

                <table
                  style={{
                    width: "100%",
                    marginLeft: "20px",
                    fontSize: "10px",
                  }}
                >
                  <tr>
                    <th></th>
                    <th style={{ fontWeight: "bold" }}>Tax Type</th>
                    <th style={{ fontWeight: "bold" }}>MOP</th>
                    <th style={{ fontWeight: "bold" }}>Previous Tax Amount </th>
                    <th style={{ fontWeight: "bold" }}>Current Tax Amount</th>
                  </tr>
                  {item.hasOwnProperty("amendedShipmentDuties") &&
                    item.amendedShipmentDuties.map((val, i) => (
                      <tr key={i}>
                        <td>{val.name}</td>
                        <td style={{ textAlign: "center" }}>{val.taxType}</td>
                        <td style={{ textAlign: "center" }}>{val.mopCode}</td>
                        <td style={{ textAlign: "center" }}>
                          {val.prevTotalRevenue}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {val.currTotalRevenue}
                        </td>
                      </tr>
                    ))}
                </table>
              </>
            )}

            {item.hasOwnProperty("amendedHeaderLabel") === true &&
              item.hasOwnProperty("amendedHeaderValues") === true && (
                <>
                  <div style={{ fontWeight: "bold" }}>
                    CONSIGNMENT AMENDMENTS
                  </div>
                  <br />
                  <div style={{ marginLeft: "20px" }}>
                    {item.amendedHeaderLabel}
                  </div>
                  <div style={{ marginLeft: "20px" }}>from</div>
                  {item.amendedHeaderValues.map((x) => (
                    <div style={{ marginLeft: "20px" }}>{x.from}</div>
                  ))}
                  <div style={{ marginLeft: "20px" }}>to</div>
                  {item.amendedHeaderValues.map((x) => (
                    <div style={{ marginLeft: "20px" }}>{x.to}</div>
                  ))}
                </>
              )}
            {item.hasOwnProperty("amendedItemDetails") === true && (
              <div style={{ fontWeight: "bold" }}>ITEM AMENDMENTS</div>
            )}
            {item.hasOwnProperty("amendedItemDetails") === true &&
              item.amendedItemDetails.map((element) => (
                <>
              {element.hasOwnProperty("itemNo") === true && (
                    <div>Item number  {element.itemNo} </div>
                  )}
                  {element.hasOwnProperty("prevDuties") === true && (
                    <div>Previous Tax Lines:</div>
                  )}
                  {element.hasOwnProperty("prevDuties") === true && (
                    <table
                      style={{
                        width: "100%",
                        marginLeft: "20px",
                        fontSize: "10px",
                      }}
                    >
                      <tr>
                        <th></th>
                        <th style={{ fontWeight: "bold" }}>Tax Type</th>
                        <th style={{ fontWeight: "bold" }}>Base Amount</th>
                        <th style={{ fontWeight: "bold" }}>Base Quantity</th>
                        <th style={{ fontWeight: "bold" }}>Tax Rate</th>
                        <th style={{ fontWeight: "bold",width:"12%"  }}>Tax Amount</th>
                        <th style={{ fontWeight: "bold" }}>MOP</th>
                      </tr>
                      {element.prevDuties.map((val, i) => (
                        <tr key={i}>
                          <td>{val.name}</td>
                          <td style={{ textAlign: "center" }}>{val.taxType}</td>
                          <td style={{ textAlign: "center" }}>{val.taxBase}</td>
                          <td style={{ textAlign: "center" }}>
                            {val.taxBaseQuantity}
                          </td>
                          <td style={{ textAlign: "center" }}>{val.taxRate}</td>
                          <td style={{ textAlign: "center" ,float:"right"}}>
                            {val.taxAmount}
                          </td>
                          <td style={{ textAlign: "center" }}>{val.mopCode}</td>
                        </tr>
                      ))}
                    </table>
                  )}
                  <br />
                  {element.hasOwnProperty("currentDuties") === true && (
                    <div>Current Tax Lines:</div>
                  )}
                  {element.hasOwnProperty("currentDuties") === true && (
                    <table
                      style={{
                        width: "100%",
                        marginLeft: "20px",
                        fontSize: "10px",
                      }}
                    >
                      <tr>
                        <th></th>
                        <th style={{ fontWeight: "bold" }}>Tax Type</th>
                        <th style={{ fontWeight: "bold" }}>Base Amount</th>
                        <th style={{ fontWeight: "bold" }}>Base Quantity</th>
                        <th style={{ fontWeight: "bold" }}>Tax Rate</th>
                        <th style={{ fontWeight: "bold",width:"12%" }}>Tax Amount</th>
                        <th style={{ fontWeight: "bold" }}>MOP</th>
                      </tr>
                      {element.currentDuties.map((val, i) => (
                        <tr key={i}>
                          <td>{val.name}</td>
                          <td style={{ textAlign: "center" }}>{val.taxType}</td>
                          <td style={{ textAlign: "center" }}>{val.taxBase}</td>
                          <td style={{ textAlign: "center" }}>
                            {val.taxBaseQuantity}
                          </td>
                          <td style={{ textAlign: "center" }}>{val.taxRate}</td>
                          <td style={{ textAlign: "center",float:"right" }}>
                            {val.taxAmount}
                          </td>
                          <td style={{ textAlign: "center" }}>{val.mopCode}</td>
                        </tr>
                      ))}
                    </table>
                  )}
                  {element.hasOwnProperty("amendedItemValues") === true &&
                    element.hasOwnProperty("amendedItemLabel") === true && (
                      <>
                        <div>Item Amendments</div>
                        <br />
                        <div style={{ marginLeft: "20px" }}>
                          {element.amendedItemLabel}
                        </div>
                        <div style={{ marginLeft: "20px" }}>from</div>
                        {element.amendedItemValues.map((x) => (
                          <div style={{ marginLeft: "20px" }}>{x.from}</div>
                        ))}
                        <div style={{ marginLeft: "20px" }}>to</div>
                        {element.amendedItemValues.map((x) => (
                          <div style={{ marginLeft: "20px" }}>{x.to}</div>
                        ))}
                      </>
                    )}
                </>
              ))}

            {(item.messageCode === "IFD" ||
              item.hasOwnProperty("reportType") === true) && (
              <div id="entry-value-details" style={{ marginTop: "5px" }}>
                {item.hasOwnProperty("valueDetails") && (
                  <div style={{ fontWeight: "bold" }}>ENTRY VALUE DETAILS</div>
                )}

                {item.hasOwnProperty("valueDetails") &&
                
                    <table
                      style={{
                        width: "100%",
                        marginLeft: "20px",
                        fontSize: "10px",
                      }}
                    >
                      <tr>
                        <th></th>
                        <th style={{ fontWeight: "bold" }}>Amount from</th>
                        <th style={{ fontWeight: "bold" }}>Curency at</th>
                        <th style={{ fontWeight: "bold" }}>Exchange Rate</th>
                      </tr>
                      {item.valueDetails.map((val, i) => (
                      <tr key={i}>
                        <td>{val.name}</td>
                        <td style={{ textAlign: "center" }}>{val.amount}</td>
                        <td style={{ textAlign: "center" }}>{val.currency}</td>
                        <td style={{ textAlign: "center" }}>
                          {val.exchangeRate}
                        </td>
                      </tr>))}
                    </table>
                  }
              </div>
            )}
            {/* <br /> */}
            {(item.messageCode === "IFD" ||
              item.hasOwnProperty("reportType") === true) && (
              <div id="entry-revenue-totals" style={{ marginTop: "5px" }}>
                {item.hasOwnProperty("shipmentDuties") && (
                  <div style={{ fontWeight: "bold" }}>ENTRY REVENUE TOTALS</div>
                )}

                {item.hasOwnProperty("shipmentDuties") &&
              
                    <div
                      style={{
                        display: "table",
                        width: "100%",
                        height: "50px",
                      }}
                    >
                      <div
                        style={{ display: "table-cell", width: "50%" }}
                       
                      >
                      
                        <table style={{ fontSize: "9px" }}>
                          <tr>
                            <th style={{ fontWeight: "bold" }}>Tax Type</th>
                            <th style={{ fontWeight: "bold",width:"12%" }}>Total Amount</th>
                            <th style={{ fontWeight: "bold" }}>MOP</th>
                          </tr>
                         { item.shipmentDuties.map((val, i) => (
                          <tr  key={i}>
                            <td style={{ textAlign: "center" }}>
                              {val.taxType}
                            </td>
                            <td style={{ textAlign: "center",float:"right" }}>
                              {val.taxAmount}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {val.mopCode}
                            </td>
                          </tr>))}
                        </table>
                      </div>
                    </div>
                  }
              </div>
            )}

            {(item.hasOwnProperty("deferredDuty") === true ||
              item.hasOwnProperty("immDuty") === true ||
              item.hasOwnProperty("dutyPayable") === true) && (
              <div>
                <table
                  style={{
                    width: "60%",
                    marginLeft: "20px",
                    fontSize: "10px",
                  }}
                >
                  {item.hasOwnProperty("deferredDuty") === true && (
                    <tr>
                      <td style={{ fontWeight: "bold", width:" 83%" }}>
                        Total deferred revenue
                      </td>
                      <td style={{ fontWeight: "bold" }}>
                        {item.deferredDuty}
                      </td>
                    </tr>
                  )}
                  {item.hasOwnProperty("immDuty") === true && (
                    <tr>
                      <td style={{ fontWeight: "bold", width:" 83%" }}>
                        {" "}
                        Total immediate revenue
                      </td>
                      <td style={{ fontWeight: "bold" }}>{item.immDuty}</td>
                    </tr>
                  )}
                  {item.hasOwnProperty("dutyPayable") === true && (
                    <tr>
                      <td style={{ fontWeight: "bold" , width:" 83%"}}>
                        Total revenue payable
                      </td>
                      <td style={{ fontWeight: "bold" }}>{item.dutyPayable}</td>
                    </tr>
                  )}
                </table>
              </div>
            )}

            <br />
            {(item.messageCode === "IFD" ||
              item.hasOwnProperty("reportType") === true) && (
              <div>
                {item.hasOwnProperty("itemDetails") && (
                  <div style={{ fontWeight: "bold", marginTop: "-13px" }}>
                    Item details
                  </div>
                )}
                {item.hasOwnProperty("itemDetails") &&
                  item.itemDetails.map((val, i) => (
                    <div id="item-details" style={{ marginTop: "27px" }} key={i}>
                      <div style={{ marginLeft: "10px", fontWeight: "bold" }}>
                        Item {val.itemNo}
                      </div>
                      <table
                        style={{
                          float: "right",
                          fontSize: "10px",
                          width: "74%",
                        }}
                      >
                        <tr>
                          {val.hasOwnProperty("invoicePrice") && (
                            <td>Item price {val.invoicePrice}</td>
                          )}
                          {val.hasOwnProperty("vatValue") && (
                            <td>Vat value {val.vatValue}</td>
                          )}
                          {val.hasOwnProperty("statValue") && (
                            <td>Stat  value {val.statValue}</td>
                          )}
                        </tr>
                        <tr>
                          {val.hasOwnProperty("customsValue") && (
                            <td>Customs value {val.customsValue}</td>
                          )}
                          {val.hasOwnProperty("licenseValue") && (
                            <td>Licence value {val.licenseValue}</td>
                          )}
                        </tr>
                   
                        <br/>
                      </table>
                    
                     <br/>
                      {val.hasOwnProperty("itemDuties") &&
                     
                          <div
                            style={{
                              display: "table",
                              width: "100%",
                              height: "50px",
                            }}
                          >
                            <div
                              style={{ display: "table-cell", width: "50%" }}
                             
                            >
                              <table style={{ fontSize: "10px" }}>
                                <tr>
                                  <th style={{ fontWeight: "bold" }}>
                                    Tax Type
                                  </th>
                                  <th style={{ fontWeight: "bold", width :"12%"}}>
                                    Total Amount
                                  </th>
                                  <th style={{ fontWeight: "bold" }}>MOP</th>
                                </tr>
                                {val.itemDuties.map((iii, i) => (
                                <tr  key={i}>
                                  <td style={{ textAlign: "center" }}>
                                    {iii.taxType}
                                  </td>
                                  <td style={{ textAlign: "center" , float : "right" }}>
                                    {iii.taxAmount}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {iii.mopCode}
                                  </td>
                                </tr>))}
                                <br/>
                              </table>
                            </div>
                          </div>
                        }
                    </div>
                   
                  ))}
                  <br/>
              </div>
            
             
            )}

            {item.hasOwnProperty("segments") === true &&
              item.segments.map(
                (element) =>
                  element.hasOwnProperty("reasons") === true && (
                    <div style={{ whiteSpace: "pre-line", fontSize: "10px" }}>
                      {element.reasons.join(" ")}
                    </div>
                  )
              )}
            <div style={{ height: "20px", marginTop: "25px" }}>
              {/* <div style={{ float: "left" }}>[722732788]</div> */}
              <div style={{ textAlign: "center" }}>
                END OF REPORT{" "}
                {item.hasOwnProperty("reportType") === true
                  ? item.reportType : item.hasOwnProperty("messageCode") === true && item.messageCode === "XTC"? "XTC" 
                  : "DTI-H2"}{" "}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="error">
          <div style={{ fontWeight: "bold", textAlign: "center" }}>
            Error details
          </div>
          <div style={{ height: "20px", display: "table", marginTop: "20px" }}>
            <div style={{ display: "table-cell", fontWeight: "bold" }}>
              Error Code
            </div>
            <div
              style={{
                paddingLeft: "26px",
                paddingRight: "30px",
                fontWeight: "bold",
                display: "table-cell",
              }}
            >
              Error Message
            </div>
          </div>
          {item.hasOwnProperty("errors") &&
            item.errors.map((iii, i) => (
              <div style={{ display: "table", fontSize: "11px" }}>
                <div style={{ display: "table-cell" }}>{iii.errorCode}</div>
                <div
                  style={{
                    display: "table-cell",
                    paddingLeft: "74px",
                    paddingRight: "30px",
                    whiteSpace: "pre-line",
                  }}
                >
                  {iii.errorMessage}{" "}
                  {iii.hasOwnProperty("invoiceNumber") === true &&
                    "Invoice No" +
                      " " +
                      (iii.invoiceNumber < 10
                        ? `00${iii.invoiceNumber}`
                        : iii.invoiceNumber < 99
                        ? `0${iii.invoiceNumber}`
                        : iii.invoiceNumber)}{" "}
                  {iii.hasOwnProperty("lineNumber") === true &&
                    "LineItem No" +
                      " " +
                      (iii.lineNumber < 10
                        ? `00${iii.lineNumber}`
                        : iii.lineNumber < 99
                        ? `0${iii.lineNumber}`
                        : iii.lineNumber)}{" "}
                  {iii.hasOwnProperty("commodityCode") === true &&
                    iii.hasOwnProperty("invoiceId") === true &&
                    iii.hasOwnProperty("merchandiseId") === true && (
                      <Popup
                        trigger={
                          <Icon
                            style={{ cursor: "pointer", color: "blue" }}
                            name="external alternate"
                            onClick={() =>
                              this.jumpToMerchandise(
                                iii.merchandiseId,
                                iii.lineNumber
                              )
                            }
                          />
                        }
                        content={"Jump To Merchandise "}
                      />
                    )}
                </div>
              </div>
            ))}
        </div>
      );
    }
  }
}

export default MessageItem;